// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TvBT","top":"styles_top__1Xu9l","left":"styles_left__1Ehjm","description":"styles_description__2-7ph"};